var ol = require('../dist/ol-debug');
require('./tilequeue');
require('./tilecancel');
require('./mousewheelzoom');
require('./allowoverlap');
require('./fixfloatzoom');
require('./touchfix');

module.exports = ol;



//////////////////
// WEBPACK FOOTER
// ./src/~/openlayers/oms/ol-wrapper.js
// module id = 22
// module chunks = 0